package fr.frux.feature.treedetail

import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.outlined.ArrowBack
import androidx.compose.material.icons.outlined.Flag
import androidx.compose.material.icons.outlined.Groups
import androidx.compose.material.icons.outlined.LocationOff
import androidx.compose.material.icons.outlined.Park
import androidx.compose.material.icons.outlined.Share
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.ListItem
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.SnackbarResult
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.unit.dp
import fr.frux.core.ads.AdHold
import fr.frux.core.ads.HoldAds
import fr.frux.core.common.share.ShareOutcome
import fr.frux.core.designsystem.components.EmptyState
import fr.frux.core.designsystem.components.ErrorState
import fr.frux.core.designsystem.components.FruxButton
import fr.frux.core.designsystem.components.FruxButtonStyle
import fr.frux.core.designsystem.components.FruxFavoriteButton
import fr.frux.core.designsystem.components.FruxIconButton
import fr.frux.core.designsystem.components.FruxModalBottomSheet
import fr.frux.core.designsystem.components.FruxPhotoSourceSheet
import fr.frux.core.designsystem.components.FruxSnackbar
import fr.frux.core.designsystem.components.LoadingState
import fr.frux.core.designsystem.components.SnackbarMessageEffect
import fr.frux.core.designsystem.components.UserModerationMessage
import fr.frux.core.designsystem.components.message
import fr.frux.core.designsystem.error.userMessage
import fr.frux.core.designsystem.icons.FruxSpeciesGlyphs
import fr.frux.core.designsystem.theme.FruxSpacing
import fr.frux.core.designsystem.theme.color
import fr.frux.core.designsystem.theme.label
import fr.frux.core.media.ImageSource
import fr.frux.core.media.rememberImagePicker
import fr.frux.feature.treedetail.components.ConfidenceBlock
import fr.frux.feature.treedetail.components.FailedPhotosNotice
import fr.frux.feature.treedetail.components.FieldObservationSection
import fr.frux.feature.treedetail.components.ImportSourceSection
import fr.frux.feature.treedetail.components.PhotoGrid
import fr.frux.feature.treedetail.components.SeasonCalendarBlock
import fr.frux.feature.treedetail.components.TraitChipRow
import fr.frux.feature.treedetail.identity.IdentityBlock
import fr.frux.feature.treedetail.identity.IdentityMessageEffect
import fr.frux.feature.treedetail.identity.IdentitySheets
import fr.frux.feature.treedetail.identity.IdentityUi
import fr.frux.feature.treedetail.move.MoveTreeArgs
import fr.frux.feature.treedetail.move.moveOrAskLogin
import fr.frux.feature.treedetail.resources.Res
import fr.frux.feature.treedetail.resources.treedetail_back_description
import fr.frux.feature.treedetail.resources.treedetail_default_username
import fr.frux.feature.treedetail.resources.treedetail_delete_dialog_cancel
import fr.frux.feature.treedetail.resources.treedetail_delete_dialog_confirm
import fr.frux.feature.treedetail.resources.treedetail_delete_dialog_text
import fr.frux.feature.treedetail.resources.treedetail_delete_dialog_title
import fr.frux.feature.treedetail.resources.treedetail_login_snackbar_action
import fr.frux.feature.treedetail.resources.treedetail_not_found_back
import fr.frux.feature.treedetail.resources.treedetail_not_found_message
import fr.frux.feature.treedetail.resources.treedetail_not_found_title
import fr.frux.feature.treedetail.resources.treedetail_refresh_failed
import fr.frux.feature.treedetail.resources.treedetail_report_gone
import fr.frux.feature.treedetail.resources.treedetail_report_maintain_identification
import fr.frux.feature.treedetail.resources.treedetail_report_withdraw_gone
import fr.frux.feature.treedetail.resources.treedetail_share_description
import fr.frux.feature.treedetail.resources.treedetail_start_harvest
import fr.frux.feature.treedetail.site.SiteAttachProposalCard
import fr.frux.feature.treedetail.site.SiteIdentityRow
import fr.frux.feature.treedetail.site.SiteLinkMessageEffect
import fr.frux.feature.treedetail.site.TreeSiteUi
import fr.frux.shared.domain.model.ObservableTreeStatus
import fr.frux.shared.domain.model.TreeTraitKind
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.stringResource

/** Clé de l'item d'en-tête : quand il sort du viewport, le titre monte dans la top bar (spec E). */
private const val HEADER_KEY = "header"

/**
 * Clé de l'item de mini-carte : sert à détecter sa présence dans `visibleItemsInfo` (préchargement
 * exclu, cf. [rememberMapPreviewReady]) pour ne créer la carte MapLibre qu'à l'affichage réel.
 */
private const val MAP_PREVIEW_KEY = "mapPreview"

/**
 * Fiche arbre (spec Fiche arbre — 3 zones) :
 * - **Identité** : pastilles statut + certitude, nom d'espèce `displayLarge`, grille photos
 *   adaptative, bloc calendrier de saison ;
 * - **Confiance** (ADR 0015) : certitude, jauge, « Signaler… », sosies. Plus de « Je confirme »
 *   depuis l'ADR 0025 : l'identification ne se vote pas ;
 * - **Vie de l'arbre** : observation de terrain, traits, récoltes prévues, créateur ou source d'import,
 *   mini-carte. Bottom bar : « Lancer une récolte ».
 *
 * @param treeId The ID of the tree to display
 * @param onBack Callback when back button is clicked
 * @param onCreatorClick Callback when creator profile is clicked
 * @param onStartHarvest Callback when "Lancer une récolte" is clicked
 * @param onMapPreviewClick Callback when map preview is clicked, avec les coordonnées de l'arbre
 *   (#323, carte plein écran centrée dessus)
 * @param onHarvestClick Callback when a row of the "Récoltes prévues" section is clicked (#226)
 * @param onLogin Callback quand l'invite de connexion (#264, anonyme sur une action réservée) est
 *   suivie depuis la snackbar
 * @param onDirections Callback du bouton « Y aller » (#335), avec les coordonnées de l'arbre et le
 *   nom de l'espèce comme étiquette — l'écran ne fabrique pas lui-même le launcher (state hoisting),
 *   sinon les tests d'écran ouvriraient une vraie appli d'itinéraire.
 * @param onShare Callback du bouton de partage de la top bar (#391), avec le nom de l'espèce —
 *   même raison de state hoisting que [onDirections], le launcher réel vit chez l'appelant.
 * @param onTreeLocated Position de l'arbre, dès que la fiche l'a chargée : la carte permanente
 *   (ADR 0009), visible à côté de la fiche en grand écran, doit pouvoir s'y rendre quand on arrive
 *   par un lien, les favoris ou l'activité plutôt que par un marqueur.
 */
@Composable
fun TreeDetailScreen(
    treeId: Long,
    onBack: () -> Unit,
    /** Sortie après une suppression réussie : par défaut le retour, l'hôte y annonce la suppression sur la carte. */
    onTreeDeleted: () -> Unit = onBack,
    onCreatorClick: (Long) -> Unit = {},
    onStartHarvest: () -> Unit = {},
    onMapPreviewClick: (latitude: Double, longitude: Double) -> Unit = { _, _ -> },
    /** Ouvre l'écran de déplacement de l'arbre (« Déplacer » du bloc Identité), seulement avec un compte. */
    onMoveTree: (MoveTreeArgs) -> Unit = {},
    onHarvestClick: (Long) -> Unit = {},
    onLogin: () -> Unit = {},
    onDirections: (latitude: Double, longitude: Double, label: String) -> Unit = { _, _, _ -> },
    onShare: suspend (speciesName: String) -> ShareOutcome = { ShareOutcome.FAILED },
    onTreeLocated: (latitude: Double, longitude: Double) -> Unit = { _, _ -> },
    /** Ouvre la fiche du lieu de l'arbre (ligne « Lieu » du bloc Identité). */
    onOpenSite: (Long) -> Unit = {},
    modifier: Modifier = Modifier,
    viewModel: TreeDetailViewModel = rememberTreeDetailViewModel(treeId),
) {
    val state by viewModel.state.collectAsState()
    val siteUi by viewModel.siteLink.state.collectAsState()
    val snackbarHostState = remember { SnackbarHostState() }
    val coroutineScope = rememberCoroutineScope()
    TreeDetailSnackbarEffects(state, siteUi, snackbarHostState, viewModel, onLogin, onBack)

    TreeDetailEventsEffect(viewModel.events, onTreeDeleted, onLogin)

    // Retour sur la fiche (#224) : le ViewModel survit à l'aller-retour vers un autre écran (retenu par le
    // ViewModelStore de Nav3), donc `init` ne relance pas le chargement à la remontée — c'est
    // cette Composable qui, elle, est bien recomposée à chaque retour au sommet de la pile.
    // `onScreenResumed` sait ne pas dupliquer le GET déjà fait par `init` sur la toute première
    // composition (voir sa doc).
    LaunchedEffect(Unit) { viewModel.onScreenResumed() }

    TreeLocatedEffect(state.tree?.latitude, state.tree?.longitude, onTreeLocated)

    var showDeleteConfirmation by remember { mutableStateOf(false) }
    // Feuille et confirmation de l'ADR 0029 : état d'affichage local, comme la suppression.
    var showReportUserSheet by remember { mutableStateOf(false) }
    var showBlockDialog by remember { mutableStateOf(false) }
    TreeDetailSensitiveFlowHold(
        state = state,
        showReportUserSheet = showReportUserSheet,
        showBlockDialog = showBlockDialog,
    )

    val listState = rememberLazyListState()
    // Titre de top bar seulement quand le nom d'espèce (item d'en-tête) est sorti du viewport
    // (spec E) ; tant que la liste n'a pas mesuré, on reste sans titre.
    val showTopBarTitle by remember {
        derivedStateOf {
            val visible = listState.layoutInfo.visibleItemsInfo
            visible.isNotEmpty() && visible.none { it.key == HEADER_KEY }
        }
    }
    // La mini-carte ne s'active que si son item est réellement affiché (pas seulement préchargé
    // par la LazyColumn, ce qui n'apparaît jamais dans visibleItemsInfo) ET le scroll est arrêté :
    // mesuré sur web, le préchargement instanciait MapLibre (ensureMap/setStyle/shaders) pendant
    // le défilement en haut de la fiche, avant même que la carte soit visible.
    val mapPreviewReady by remember {
        derivedStateOf {
            !listState.isScrollInProgress &&
                listState.layoutInfo.visibleItemsInfo.any { it.key == MAP_PREVIEW_KEY }
        }
    }

    Box(modifier = modifier) {
        Scaffold(
            topBar = {
                TreeDetailTopBar(
                    tree = state.tree,
                    showTitle = showTopBarTitle,
                    isFavorite = state.isFavorite,
                    onBack = onBack,
                    onFavoriteClick = viewModel::onFavoriteClick,
                    onDeleteClick = { showDeleteConfirmation = true },
                    onReportDescription = viewModel::onReportDescriptionClick,
                    onReportCreator = { requestModerationOverlay(viewModel) { showReportUserSheet = true } },
                    onBlockCreator = { requestModerationOverlay(viewModel) { showBlockDialog = true } },
                    onShareClick = { speciesName ->
                        coroutineScope.launch {
                            showShareOutcomeSnackbar(
                                outcome = onShare(speciesName),
                                snackbarHostState = snackbarHostState,
                            )
                        }
                    },
                )
            },
            snackbarHost = { SnackbarHost(snackbarHostState) { FruxSnackbar(it) } },
            bottomBar = {
                // Lieu privé d'autrui sans récolte à venir : seul son propriétaire peut en lancer une.
                if (state.tree != null && !siteUi.harvestLocked) {
                    Surface(shadowElevation = 4.dp, color = MaterialTheme.colorScheme.background) {
                        Column(
                            modifier =
                                Modifier
                                    .fillMaxWidth()
                                    .padding(FruxSpacing.md),
                            horizontalAlignment = Alignment.CenterHorizontally,
                        ) {
                            FruxButton(
                                text = stringResource(Res.string.treedetail_start_harvest),
                                onClick = onStartHarvest,
                                icon = Icons.Outlined.Groups,
                                modifier = Modifier.fillMaxWidth(),
                            )
                        }
                    }
                }
            },
            containerColor = MaterialTheme.colorScheme.background,
        ) { paddingValues ->
            when {
                state.isLoading -> {
                    LoadingState(Modifier.padding(paddingValues))
                }

                state.notFound -> {
                    EmptyState(
                        icon = Icons.Outlined.Park,
                        title = stringResource(Res.string.treedetail_not_found_title),
                        message = stringResource(Res.string.treedetail_not_found_message),
                        ctaLabel = stringResource(Res.string.treedetail_not_found_back),
                        onCta = onBack,
                        modifier = Modifier.padding(paddingValues),
                    )
                }

                state.error != null -> {
                    ErrorState(
                        message = state.error!!.userMessage(),
                        onRetry = viewModel::retry,
                        modifier = Modifier.padding(paddingValues),
                    )
                }

                else -> {
                    state.tree?.let { tree ->
                        // Picker au niveau écran : `rememberImagePicker` n'est composé qu'une fois, le
                        // résultat va directement au ViewModel (#223 lot C).
                        var showPhotoSourceSheet by remember { mutableStateOf(false) }
                        val picker =
                            rememberImagePicker(onResult = { image ->
                                image?.let(viewModel::uploadPhoto)
                            })
                        // Desktop/iOS sans picker câblé : le bouton ne s'affiche pas plutôt que
                        // d'offrir une action morte (même garde que l'assistant d'ajout).
                        val onAddPhotoClick: (() -> Unit)? =
                            if (picker.availableSources.isEmpty()) {
                                null
                            } else {
                                {
                                    if (picker.availableSources.size > 1) {
                                        showPhotoSourceSheet = true
                                    } else {
                                        picker.launch(picker.availableSources.first())
                                    }
                                }
                            }

                        TreeDetailContent(
                            tree = tree,
                            listState = listState,
                            mapPreviewReady = mapPreviewReady,
                            activeHarvests = state.activeHarvests,
                            onHarvestClick = onHarvestClick,
                            onObserveStatus = viewModel::onObserveStatus,
                            isObservationPending = state.isObservationPending,
                            onTraitClick = viewModel::onTraitClick,
                            pendingTraits = state.pendingTraits,
                            onCreatorClick = { onCreatorClick(tree.createdBy) },
                            onMapPreviewClick = { onMapPreviewClick(tree.latitude, tree.longitude) },
                            onDirections = { onDirections(tree.latitude, tree.longitude, tree.speciesName) },
                            onReportGoneClick = viewModel::onReportGoneClick,
                            onWithdrawGoneReportClick = viewModel::onWithdrawGoneReportClick,
                            onMaintainIdentificationClick = viewModel::onMaintainIdentificationClick,
                            isReportPending = state.isReportPending,
                            isUploadingPhoto = state.isUploadingPhoto,
                            onAddPhotoClick = onAddPhotoClick,
                            failedPhotoCount = state.failedPhotoIds.size,
                            onRetryFailedPhotos = viewModel.pendingPhotos::retry,
                            onRemoveFailedPhotos = viewModel.pendingPhotos::remove,
                            isReportingPhoto = state.isReportingPhoto,
                            onReportPhotoClick = viewModel::reportPhoto,
                            isDeletingPhoto = state.isDeletingPhoto,
                            onDeletePhotoClick = viewModel::deletePhoto,
                            identity = state.identity,
                            onCorrectSpecies = viewModel.identity::openSpecies,
                            onMove = { viewModel.identity.moveOrAskLogin(tree, onMoveTree) },
                            onEditNote = viewModel.identity::openNote,
                            onHistory = viewModel.identity::openHistory,
                            site = siteUi,
                            onAttachSite = viewModel.siteLink::attach,
                            onDismissSite = viewModel.siteLink::dismissProposal,
                            onOpenSite = onOpenSite,
                            onDetachSite = viewModel.siteLink::detach,
                            modifier = Modifier.padding(paddingValues),
                        )

                        if (showPhotoSourceSheet) {
                            FruxPhotoSourceSheet(
                                onCamera = {
                                    showPhotoSourceSheet = false
                                    picker.launch(ImageSource.CAMERA)
                                },
                                onGallery = {
                                    showPhotoSourceSheet = false
                                    picker.launch(ImageSource.GALLERY)
                                },
                                onDismiss = { showPhotoSourceSheet = false },
                            )
                        }
                    }
                }
            }
        }
        IdentitySheets(
            tree = state.tree,
            sheet = state.identity.sheet,
            controller = viewModel.identity,
            onReportDoubt = viewModel::onReportClick,
            onWithdrawDoubt = viewModel::onWithdrawReportClick,
        )
    }

    if (showDeleteConfirmation) {
        AlertDialog(
            onDismissRequest = { showDeleteConfirmation = false },
            title = { Text(stringResource(Res.string.treedetail_delete_dialog_title)) },
            text = {
                Text(stringResource(Res.string.treedetail_delete_dialog_text))
            },
            confirmButton = {
                FruxButton(
                    text = stringResource(Res.string.treedetail_delete_dialog_confirm),
                    onClick = {
                        showDeleteConfirmation = false
                        viewModel.onDeleteConfirmed()
                    },
                    style = FruxButtonStyle.DestructiveText,
                )
            },
            dismissButton = {
                FruxButton(
                    text = stringResource(Res.string.treedetail_delete_dialog_cancel),
                    onClick = { showDeleteConfirmation = false },
                    style = FruxButtonStyle.Text,
                )
            },
        )
    }

    TreeDetailModerationOverlays(
        creatorName = state.tree?.creatorUsername.orEmpty(),
        showReportUserSheet = showReportUserSheet,
        showBlockDialog = showBlockDialog,
        onReportUserSheetDismiss = { showReportUserSheet = false },
        onReportCreator = { reason, details ->
            showReportUserSheet = false
            viewModel.onReportCreator(reason, details)
        },
        onBlockDialogDismiss = { showBlockDialog = false },
        onBlockCreatorConfirmed = {
            showBlockDialog = false
            viewModel.onBlockCreatorConfirmed()
        },
    )
}

/**
 * Top bar de la fiche (spec E) : sans titre tant que le nom d'espèce `displayLarge` est visible
 * dans le contenu ; dès qu'il sort du viewport, le titre `titleLarge` apparaît (fade 150 ms) avec
 * la pastille statut réduite (point 8 dp) et un divider 1 px.
 */
@Composable
private fun TreeDetailTopBar(
    tree: TreeDetail?,
    showTitle: Boolean,
    isFavorite: Boolean,
    onBack: () -> Unit,
    onFavoriteClick: () -> Unit,
    onDeleteClick: () -> Unit,
    onReportDescription: () -> Unit,
    onReportCreator: () -> Unit,
    onBlockCreator: () -> Unit,
    onShareClick: (speciesName: String) -> Unit,
) {
    var showMenu by remember { mutableStateOf(false) }
    val titleAlpha by animateFloatAsState(if (showTitle && tree != null) 1f else 0f, tween(150))
    // Barre custom (hors CenterAlignedTopAppBar) : les insets ne sont plus gérés par M3 — le fond
    // est peint AVANT le padding pour couvrir la status bar en edge-to-edge.
    Column(
        Modifier
            .background(MaterialTheme.colorScheme.background)
            .windowInsetsPadding(WindowInsets.statusBars),
    ) {
        Row(
            modifier =
                Modifier
                    .fillMaxWidth()
                    .height(64.dp)
                    .padding(horizontal = FruxSpacing.xs),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            FruxIconButton(
                icon = Icons.AutoMirrored.Outlined.ArrowBack,
                contentDescription = stringResource(Res.string.treedetail_back_description),
                onClick = onBack,
            )
            Row(
                modifier = Modifier.weight(1f).alpha(titleAlpha),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(FruxSpacing.sm, Alignment.CenterHorizontally),
            ) {
                // Composé seulement quand visible : un titre en alpha 0 resterait dans l'arbre
                // sémantique et dupliquerait le nom d'espèce pour un lecteur d'écran.
                if (tree != null && titleAlpha > 0f) {
                    Text(
                        text = tree.speciesName,
                        style = MaterialTheme.typography.titleLarge,
                        maxLines = 1,
                    )
                    Box(
                        Modifier
                            .size(8.dp)
                            .clip(CircleShape)
                            .background(tree.status.color()),
                    )
                }
            }
            if (tree != null) {
                // Partage (#391), avant le favori : action de diffusion, pas de gestion perso.
                FruxIconButton(
                    icon = Icons.Outlined.Share,
                    contentDescription = stringResource(Res.string.treedetail_share_description),
                    onClick = { onShareClick(tree.speciesName) },
                )
                FruxFavoriteButton(
                    isFavorite = isFavorite,
                    onClick = onFavoriteClick,
                    // Cœur actif teinté accentCherry (#198) ; l'état inactif garde la
                    // teinte neutre habituelle des actions de la top bar.
                    inactiveTint = MaterialTheme.colorScheme.primary,
                )
                // Supprimer (#224) pour le propriétaire. Pour l'arbre d'autrui, gestes de
                // l'ADR 0029 (#515) : signaler la description, signaler ou masquer l'auteur.
                TreeDetailActionsMenu(
                    tree = tree,
                    showMenu = showMenu,
                    onShowMenuChange = { showMenu = it },
                    onDeleteClick = onDeleteClick,
                    onReportDescription = onReportDescription,
                    onReportCreator = onReportCreator,
                    onBlockCreator = onBlockCreator,
                )
            }
        }
        if (titleAlpha > 0f) {
            HorizontalDivider(
                modifier = Modifier.alpha(titleAlpha),
                color = MaterialTheme.colorScheme.outlineVariant,
            )
        }
    }
}

/** Snackbars one-shot pilotés par le state VM (cf. mémoire Nav3 : pas d'effet local d'écran). */
@Composable
private fun TreeDetailSnackbarEffects(
    state: TreeDetailState,
    siteUi: TreeSiteUi,
    snackbarHostState: SnackbarHostState,
    viewModel: TreeDetailViewModel,
    onLogin: () -> Unit,
    onBack: () -> Unit,
) {
    IdentityMessageEffect(state.identity, viewModel.identity, snackbarHostState)
    SiteLinkMessageEffect(siteUi, viewModel.siteLink, snackbarHostState)

    SnackbarMessageEffect(
        trigger = state.loginPrompt,
        message = state.loginPrompt?.message(),
        snackbarHostState = snackbarHostState,
        actionLabel = stringResource(Res.string.treedetail_login_snackbar_action),
    ) { result ->
        viewModel.consumeLoginPrompt()
        if (result == SnackbarResult.ActionPerformed) onLogin()
    }

    SnackbarMessageEffect(
        trigger = state.observationError,
        message = state.observationError?.userMessage(),
        snackbarHostState = snackbarHostState,
    ) { viewModel.consumeObservationError() }

    SnackbarMessageEffect(
        trigger = state.traitError,
        message = state.traitError?.userMessage(),
        snackbarHostState = snackbarHostState,
    ) { viewModel.consumeTraitError() }

    SnackbarMessageEffect(
        trigger = state.favoriteError,
        message = state.favoriteError?.userMessage(),
        snackbarHostState = snackbarHostState,
    ) { viewModel.consumeFavoriteError() }

    SnackbarMessageEffect(
        trigger = state.reportError,
        message = state.reportError?.userMessage(),
        snackbarHostState = snackbarHostState,
    ) { viewModel.consumeReportError() }

    SnackbarMessageEffect(
        trigger = state.photoMessage,
        message = state.photoMessage?.message(),
        snackbarHostState = snackbarHostState,
    ) { viewModel.consumePhotoMessage() }

    SnackbarMessageEffect(
        trigger = state.deleteError,
        message = state.deleteError?.userMessage(),
        snackbarHostState = snackbarHostState,
    ) { viewModel.consumeDeleteError() }

    SnackbarMessageEffect(
        trigger = state.refreshFailed,
        message = if (state.refreshFailed) stringResource(Res.string.treedetail_refresh_failed) else null,
        snackbarHostState = snackbarHostState,
    ) { viewModel.consumeRefreshError() }

    // Masquer depuis la fiche ramène à la carte après l'annonce (ADR 0029) : la carte recharge
    // son lot sans ce compte (MapViewModel.contentVisibilityChanges).
    val leavesAfterMessage = state.moderationMessage is UserModerationMessage.Blocked
    SnackbarMessageEffect(
        trigger = state.moderationMessage,
        message = state.moderationMessage?.message(),
        snackbarHostState = snackbarHostState,
    ) {
        viewModel.consumeModerationMessage()
        if (leavesAfterMessage) onBack()
    }
}

/**
 * Main content for tree detail.
 */
@Composable
private fun TreeDetailContent(
    tree: TreeDetail,
    listState: androidx.compose.foundation.lazy.LazyListState,
    mapPreviewReady: Boolean,
    activeHarvests: List<TreeHarvestItem>,
    onHarvestClick: (Long) -> Unit,
    onObserveStatus: (ObservableTreeStatus) -> Unit,
    isObservationPending: Boolean,
    onTraitClick: (TreeTraitKind) -> Unit,
    pendingTraits: Set<TreeTraitKind>,
    onCreatorClick: () -> Unit,
    onMapPreviewClick: () -> Unit,
    onDirections: () -> Unit,
    onReportGoneClick: () -> Unit,
    onWithdrawGoneReportClick: () -> Unit,
    onMaintainIdentificationClick: () -> Unit,
    isReportPending: Boolean,
    isUploadingPhoto: Boolean,
    onAddPhotoClick: (() -> Unit)?,
    failedPhotoCount: Int,
    onRetryFailedPhotos: () -> Unit,
    onRemoveFailedPhotos: () -> Unit,
    isReportingPhoto: Boolean,
    onReportPhotoClick: (String) -> Unit,
    isDeletingPhoto: Boolean,
    onDeletePhotoClick: (String) -> Unit,
    identity: IdentityUi,
    onCorrectSpecies: () -> Unit,
    onMove: () -> Unit,
    onEditNote: () -> Unit,
    onHistory: () -> Unit,
    site: TreeSiteUi,
    onAttachSite: () -> Unit,
    onDismissSite: () -> Unit,
    onOpenSite: (Long) -> Unit,
    onDetachSite: () -> Unit,
    modifier: Modifier = Modifier,
) {
    // Signalement par les pairs (#129 lot B/C, ADR 0015), regroupé derrière un seul bouton
    // « Signaler… » (bloc Confiance) plutôt qu'une liste de liens à même l'écran.
    var showReportSheet by remember { mutableStateOf(false) }
    HoldAds(AdHold.SENSITIVE_FLOW, active = showReportSheet)
    // Libellés capturés en composition (pas dans reportSheetActions, fonction pure non-composable).
    val reportLabels =
        ReportActionLabels(
            maintainIdentification = stringResource(Res.string.treedetail_report_maintain_identification),
            withdrawGoneReport = stringResource(Res.string.treedetail_report_withdraw_gone),
            gone = stringResource(Res.string.treedetail_report_gone),
        )
    val reportActions =
        reportSheetActions(
            tree = tree,
            labels = reportLabels,
            onReportGoneClick = onReportGoneClick,
            onWithdrawGoneReportClick = onWithdrawGoneReportClick,
            onMaintainIdentificationClick = onMaintainIdentificationClick,
        )

    LazyColumn(state = listState, modifier = modifier.fillMaxSize().testTag("treeDetailList")) {
        item(key = HEADER_KEY) {
            TreeHeader(tree)
        }

        // Proposition de rattachement (canvas `Rattacher`) : sous l'en-tête, avant les photos et
        // « Sur le terrain ». Elle disparaît au geste, rattaché ou écarté.
        val proposal = site.proposal
        if (proposal != null) {
            item {
                SiteAttachProposalCard(
                    proposal = proposal,
                    busy = site.busy,
                    onAttach = onAttachSite,
                    onDismiss = onDismissSite,
                    modifier = Modifier.padding(start = 20.dp, end = 20.dp, top = FruxSpacing.md),
                )
            }
        }

        item {
            PhotoGrid(
                photos = tree.photos,
                photoUrl = tree.photoUrl,
                speciesGlyph = tree.speciesGlyph,
                speciesPhoto = tree.speciesPhoto,
                speciesName = tree.speciesName,
                isUploadingPhoto = isUploadingPhoto,
                onAddPhotoClick = onAddPhotoClick,
                isReportingPhoto = isReportingPhoto,
                onReportPhotoClick = onReportPhotoClick,
                isDeletingPhoto = isDeletingPhoto,
                onDeletePhotoClick = onDeletePhotoClick,
                failedCount = failedPhotoCount,
                modifier =
                    Modifier
                        .padding(start = 20.dp, end = 20.dp, top = FruxSpacing.md)
                        .testTag("treeDetailPhotos"),
            )
        }

        if (failedPhotoCount > 0) {
            item {
                FailedPhotosNotice(
                    count = failedPhotoCount,
                    onRemove = onRemoveFailedPhotos,
                    onRetry = onRetryFailedPhotos,
                    modifier = Modifier.padding(start = 16.dp, end = 16.dp, top = FruxSpacing.md),
                )
            }
        }

        // Niveau 4 (ADR 0015) : seul rouge de l'app, sous les photos (#609 : les bandeaux
        // touchaient les pastilles en tête de fiche). Le bandeau neutre « contesté » s'empile
        // dessous quand les deux s'appliquent, 16 dp entre eux : un doute des pairs n'est jamais rouge.
        val warning = tree.hazard as? TreeHazard.LookalikeWarning
        if (warning != null) {
            item {
                HazardWarningBanner(
                    lookalikes = warning.lookalikes,
                    modifier = Modifier.padding(start = 20.dp, end = 20.dp, top = FruxSpacing.md),
                )
            }
        }
        if (tree.disputed) {
            item {
                DisputedBanner(
                    text = tree.disputedLabel,
                    modifier = Modifier.padding(start = 20.dp, end = 20.dp, top = FruxSpacing.md),
                )
            }
        }

        item {
            FieldObservationSection(
                latestObservation = tree.latestObservation,
                statusStale = tree.statusStale,
                isPending = isObservationPending,
                ripeGlyph = tree.speciesGlyph ?: FruxSpeciesGlyphs.Fleur,
                onObserve = onObserveStatus,
                modifier = Modifier.padding(start = 20.dp, end = 20.dp, top = FruxSpacing.md),
            )
        }

        item {
            IdentityBlock(
                tree = tree,
                ui = identity,
                onCorrectSpecies = onCorrectSpecies,
                onMove = onMove,
                onEditNote = onEditNote,
                onHistory = onHistory,
                modifier = Modifier.padding(start = 20.dp, end = 20.dp, top = FruxSpacing.lg),
                // Lieu connu mais pas encore lu (ou illisible) : ligne absente plutôt que « arbre isolé ».
                siteRow =
                    if (site.linkedSiteId != null && site.linked == null) {
                        null
                    } else {
                        { SiteIdentityRow(ui = site, onOpenSite = onOpenSite, onDetach = onDetachSite) }
                    },
            )
        }

        item {
            TraitChipRow(
                traits = tree.traits,
                pendingTraits = pendingTraits,
                onTraitClick = onTraitClick,
                modifier = Modifier.padding(start = 20.dp, end = 20.dp, top = FruxSpacing.lg),
            )
        }

        // Section « Récoltes prévues » (#226) : lien narratif avec le CTA "Lancer une récolte" de
        // la bottom bar, absente si la liste est vide (spec D3).
        if (activeHarvests.isNotEmpty()) {
            item {
                PlannedHarvestsSection(
                    harvests = activeHarvests,
                    onHarvestClick = onHarvestClick,
                    modifier = Modifier.padding(start = 20.dp, end = 20.dp, top = 28.dp),
                )
            }
        }

        if (tree.inSeasonMonths.isNotEmpty() && tree.seasonLabel != null) {
            item {
                SeasonCalendarBlock(
                    inSeasonMonths = tree.inSeasonMonths,
                    soonMonths = tree.soonMonths,
                    currentMonth = tree.currentMonth,
                    title = tree.seasonLabel,
                    subtitle = seasonSubtitle(tree),
                    modifier = Modifier.padding(start = 12.dp, end = 12.dp, top = 20.dp),
                )
            }
        }

        item {
            ConfidenceBlock(
                certainty = tree.certainty,
                certaintyLabel = tree.certaintyLabel,
                disputed = tree.disputed,
                isOwnTree = tree.isOwnTree,
                hasReportActions = reportActions.isNotEmpty(),
                isReportPending = isReportPending,
                onReportClick = { showReportSheet = true },
                preparationLabel = tree.preparationLabel,
                lookalikes = (tree.hazard as? TreeHazard.LookalikeInfo)?.lookalikes.orEmpty(),
                modifier = Modifier.padding(start = 12.dp, end = 12.dp, top = 12.dp),
            )
        }

        item {
            val importSource = tree.importSource
            Column(Modifier.fillMaxWidth().padding(start = 20.dp, end = 20.dp, top = FruxSpacing.lg)) {
                if (importSource != null) {
                    ImportSourceSection(importSource)
                } else {
                    CreatorSection(
                        creatorUsername =
                            tree.creatorUsername?.takeIf { it.isNotBlank() }
                                ?: stringResource(Res.string.treedetail_default_username),
                        createdAtMillis = tree.createdAt,
                        onClick = onCreatorClick,
                    )
                }
            }
        }

        // Item séparé et à clé stable (cf. mapPreviewReady) : c'est ce qui permet de détecter que
        // la mini-carte est réellement affichée, distinct d'un simple préchargement de la LazyColumn.
        item(key = MAP_PREVIEW_KEY) {
            TreeLifeSectionMap(
                tree = tree,
                mapPreviewReady = mapPreviewReady,
                onMapPreviewClick = onMapPreviewClick,
                onDirections = onDirections,
            )
        }
    }

    if (showReportSheet) {
        ReportActionsSheet(
            actions = reportActions,
            onDismiss = { showReportSheet = false },
        )
    }
}

/** Sous-titre du bloc calendrier, selon la position du mois courant dans la saison (spec D). */
private fun seasonSubtitle(tree: TreeDetail): String =
    when (tree.currentMonth) {
        in tree.inSeasonMonths -> "En pleine saison de récolte"
        in tree.soonMonths -> "Bientôt mûr"
        else -> "Hors saison"
    }

/**
 * Une action de signalement offerte dans la feuille « Signaler… » : libellé, icône et handler,
 * dans l'ordre où [reportSheetActions] les construit.
 */
private data class ReportAction(
    val label: String,
    val icon: ImageVector,
    val onClick: () -> Unit,
)

/** Libellés des actions de signalement, capturés en composition (cf. [reportSheetActions]). */
private data class ReportActionLabels(
    val maintainIdentification: String,
    val withdrawGoneReport: String,
    val gone: String,
)

/**
 * Construit la liste des actions de signalement visibles pour cet arbre — même arbre de
 * conditions que l'ancien rendu en ligne (#129 lots B/C, ADR 0015), copié tel quel : masqué sur
 * son propre arbre sauf « Maintenir mon identification » quand contesté, signalement de
 * disparition indépendant du signalement d'identification. [labels] est résolu par l'appelant
 * (composable) : cette fonction reste pure, pas de `stringResource` hors composition.
 */
private fun reportSheetActions(
    tree: TreeDetail,
    labels: ReportActionLabels,
    onReportGoneClick: () -> Unit,
    onWithdrawGoneReportClick: () -> Unit,
    onMaintainIdentificationClick: () -> Unit,
): List<ReportAction> =
    buildList {
        // Le doute d'identification et son retrait vivent au pied de la feuille « Corriger l'espèce ».
        if (tree.isOwnTree && tree.disputed) {
            add(ReportAction(labels.maintainIdentification, Icons.Outlined.Flag, onMaintainIdentificationClick))
        }

        if (!tree.isOwnTree) {
            if (tree.reportedGoneByMe) {
                add(
                    ReportAction(
                        labels.withdrawGoneReport,
                        Icons.Outlined.LocationOff,
                        onWithdrawGoneReportClick,
                    ),
                )
            } else {
                add(ReportAction(labels.gone, Icons.Outlined.LocationOff, onReportGoneClick))
            }
        }
    }

/** Feuille listant les actions de signalement, patron de [FruxPhotoSourceSheet] : ferme après tap. */
@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun ReportActionsSheet(
    actions: List<ReportAction>,
    onDismiss: () -> Unit,
) {
    FruxModalBottomSheet(onDismiss = onDismiss) {
        actions.forEach { action ->
            ListItem(
                headlineContent = { Text(action.label) },
                leadingContent = { Icon(action.icon, contentDescription = null) },
                modifier =
                    Modifier.clickable {
                        onDismiss()
                        action.onClick()
                    },
            )
        }
        Spacer(Modifier.height(FruxSpacing.lg))
    }
}
